$(document).ready(function() {

  /**
  * Coffee cunsumption calculator.
  *
  */
  function setup_subscription_calculator() {
    $('input[type=range]').rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider',
      horizontalClass: 'rangeslider--horizontal',
      fillClass: 'rangeslider__fill',
      handleClass: 'rangeslider__handle'
    });
    
    var week_amount = $('.week-amount')[0];
    var cup_icon = $('.cup-icon')[0];
    var cup_result = $('.cup-result')[0];
    var oz_result = $('.oz-result')[0];
    
    // var fourw = '<strong>4</strong> weeks';
    // var threew = '<strong>3</strong> weeks';
    // var twow = '<strong>2</strong> weeks';
    // var onew = '<strong>1</strong> week';
    
    // var expect1x4_4 = 'over the weekend';
    // var expect1x3_1 = 'every workday';
    // var expect1x2_1 = 'each day of the week';
    // var expect1x1_2 = 'a day, every day';
    // var expect2x3_2 = 'every workday';
    // var expect2x1_4 = 'all day long';
    
    // var total4 = '4';
    // var total5 = '5';
    // var total7 = '7';
    // var total10 = '10';
    // var total14 = '14';
    // var total32 = '32';
    
    $('.range-container').on('input', 'input[type="range"]', function(e) {
      
      var cup_amount = e.currentTarget.value;
      cup_icon.innerHTML = cup_amount;
      oz_result.innerHTML = cup_amount*10;
      if ( cup_amount == 1 ) {
        cup_result.innerHTML = 'cup';
      } else {
        cup_result.innerHTML = 'cups';
      }
      // if ( amount < 5 ) {
      //   $('#box-count').attr('class', 'single-box');
      //   $('.box-amount')[0].innerHTML = 'one box';
      // } else {
      //   $('#box-count').attr('class', 'double-box');
      //   $('.box-amount')[0].innerHTML = 'two boxes';
      // }
      
      // if ( amount == 1 ) {
      //   cup_icon.innerHTML = '1';
      //   cup_result.innerHTML = 'cup';
      //   week_amount.innerHTML = fourw;
      //   week_result.innerHTML = total4;
      // } else if ( amount == 2 ) { 
      //   cup_icon.innerHTML = '2';
      //   cup_result.innerHTML = 'cups';
      //   week_amount.innerHTML = threew;
      //   week_result.innerHTML = total5;
      // } else if ( amount == 3 ) {
      //   cup_icon.innerHTML = '1';
      //   cup_result.innerHTML = expect1x2_1;
      //   week_amount.innerHTML = twow;
      //   week_result.innerHTML = total7;
      // } else if ( amount == 4 ) {
      //   cup_icon.innerHTML = '2';
      //   cup_result.innerHTML = expect1x1_2;
      //   week_amount.innerHTML = onew;
      //   week_result.innerHTML = total14;
      // } else if ( amount == 5 ) {
      //   cup_icon.innerHTML = '2';
      //   cup_result.innerHTML = expect2x3_2;
      //   week_amount.innerHTML = threew;
      //   week_result.innerHTML = total10;
      // } else if ( amount == 6 ) {
      //   cup_icon.innerHTML = '3+';
      //   cup_result.innerHTML = expect2x1_4;
      //   week_amount.innerHTML = onew;
      //   week_result.innerHTML = total32;
      // } 
    }); 
  
    // var grabber;
    // $('.rangeslider__handle').on('mousedown touchstart', function(){
    //   grabber = this;    
    // })
    $('.rangeslider__handle').on('mouseup touchend', function(){      
      $('.output').addClass('animate'); 
      setTimeout(function () { 
        $('.output').removeClass('animate');
      }, 800);
      setTimeout(function () { 
        $('.cup-icon').addClass('animate');
      }, 400);
      setTimeout(function () { 
        $('.cup-icon').removeClass('animate');
      }, 800);
    });

    // $('#caffeinator-calculator').on('mouseup touchend', function(e) {
    //   if (e.target !== grabber) {
    //     $(grabber).trigger(e.type);
    //   }
    // });
    
    // Get the modal
    var modal = document.getElementById("caffeinator-calculator");
    
    // Get the button that opens the modal
    var btn = document.getElementById("caffeinator");
    
    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("close-modal-calculator")[0];
    
    // When the user clicks on the button, open the modal
    $(btn).click(function () {
      $(modal).css("visibility", "visible");
    });  
    
    // When the user clicks on <span> (x), close the modal
    // span.onclick = function() {
    //   modal.style.visibility = "hidden";
    // }
    
    // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function(event) {
    //   if (event.target == modal) {
    //     modal.style.visibility = "hidden";
    //   }
    // }
  }
  setup_subscription_calculator(); 

   /**
   * Add frequency plus and minus buttons for subscriptions weekly interval.
   *
   */	
  function setup_frequency_buttons() {

    //$(".frequency-selector").prependTo(".product-form__submit");
    
    setTimeout(function() {         
      $('label.frequency_select_label').html($('.appstle_subscribe_option_grid label.appstle_select_label').html());
      
      /* populate the selector box on load */
      var active_plan = $('.appstle_subscription_radio_wrapper input:radio:checked').val();
      var fbs_plan_txt = $('.freq-txt .sellingplan');
      var fbs_plan_detail = $('.freq-txt .sub-details');
      var appstle_plan_wrap = '.appstleRadioSellingPlanWrapper';
      var appstle_plan_radio = appstle_plan_wrap + ' .appstle-radio-wrapper';
      
      var plan_1 = $(appstle_plan_wrap + ' input:radio:nth(' + 0 + ')').val();
      var plan_2 = $(appstle_plan_wrap + ' input:radio:nth(' + 1 + ')').val();
      var plan_3 = $(appstle_plan_wrap + ' input:radio:nth(' + 2 + ')').val();
      var plan_4 = $(appstle_plan_wrap + ' input:radio:nth(' + 3 + ')').val();

      fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 0 + ') .sellingplan').html());
      fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 0 + ') .appstleSellingPlanDescription').html());
      $('.product-popup-modal__opener').detach().appendTo('.freq-txt')
      
      if (typeof active_plan !== 'undefined') {
        if ( active_plan == plan_1 ) {
          $('input#frequency').val(1);
          fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 0 + ') .sellingplan').html());
          fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 0 + ') .appstleSellingPlanDescription').html());
          $('.freq-minus').addClass('disabled');
        } else if ( active_plan == plan_2 ){
          $('input#frequency').val(2);
          fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 1 + ') .sellingplan').html());
          fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 1 + ') .appstleSellingPlanDescription').html());
        } else if ( active_plan == plan_3 ){
          $('input#frequency').val(3);
          fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 2 + ') .sellingplan').html());
          fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 2 + ') .appstleSellingPlanDescription').html());
        } else if ( active_plan == plan_4 ){
          $('input#frequency').val(4);
          fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 3 + ') .sellingplan').html());
          fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 3 + ') .appstleSellingPlanDescription').html());
          $('.freq-plus').addClass('disabled');
        } else {
          $('input#frequency').val(1);
          fbs_plan_txt.html( $(appstle_plan_radio + ':nth(' + 0 + ') .sellingplan').html());
          fbs_plan_detail.html( $(appstle_plan_radio + ':nth(' + 0 + ') .appstleSellingPlanDescription').html());
          $('.freq-minus').addClass('disabled');
        }
      }
      if ($('.payAsYouGoPlansDropdownWrapper').hasClass('appstle-active-option')) {
        $('.frequency-selector').addClass('active');
      }  else {
        $('.frequency-selector').addClass('inactive');
      }
      
      if ($('.appstle_subscription_wrapper_option').siblings().length > 0) {
        $('.appstle_sub_widget').addClass('multi-purchase');
      }  else {
        $('.appstle_sub_widget').addClass('one-time-buy');
      }    
      
    }, 300); 
    
    $(document).on('click', '.appstle_one_time_details_wrapper', function(){
      $('.frequency-selector').addClass('inactive');
      $('.frequency-selector').removeClass('active');
    });

    $(document).on('click', '.appstle_subscription_radio_wrapper', function(){
      $('.frequency-selector').addClass('active');
      $('.frequency-selector').removeClass('inactive');
      $('.freq-minus').addClass('disabled');
    });
    
    $('.freq-box .freq-button').on('click', function(e){
      var freq = parseInt($(this).parent('.freq-box').find('.frequency-input').val());

      $.fn.disableSelection = function() {
        return this
         .attr('unselectable', 'on')
         .css('user-select', 'none')
         .on('selectstart', false);
      };  
      $('.freq-box-wrapper').disableSelection();
      
      if($(this).hasClass('freq-plus')) {
        if(freq < 4) {
          freq++;
        }
        $('.freq-minus').removeClass('disabled');
      } else {
        if(freq > 1) {
          freq--;
        }
      }
      if($(this).hasClass('freq-minus')) {
        if(freq == 1) {
          $(this).addClass('disabled');
        }
        if(freq < 4) {
          $('.freq-plus').removeClass('disabled');
        }        
      }
      if($(this).hasClass('freq-plus')) {
        if(freq == 4) {
          $(this).addClass('disabled');
          //e.preventDefault();
        }
      }
      freq = (isNaN(freq))?1:freq;
      $(this).parent('.freq-box').find('.frequency-input').val(freq);
      
      var active_plan = $('.appstle_subscription_radio_wrapper input:radio:checked'); 
      var fbs_plan_txt = $('.freq-txt .sellingplan');
      var fbs_plan_detail = $('.freq-txt .sub-details');
      var appstle_plan_wrap = '.appstleRadioSellingPlanWrapper .appstle-radio-wrapper';
      var plan_1 = $(appstle_plan_wrap + ' input:radio:nth(' + 0 + ')');
      var plan_2 = $(appstle_plan_wrap + ' input:radio:nth(' + 1 + ')');
      var plan_3 = $(appstle_plan_wrap + ' input:radio:nth(' + 2 + ')');
      var plan_4 = $(appstle_plan_wrap + ' input:radio:nth(' + 3 + ')');
      
      if ( freq == 1 ) {
        active_plan.val(plan_1.val());
        fbs_plan_txt.html( $(appstle_plan_wrap + ':nth(' + 0 + ') .sellingplan').html() );
        fbs_plan_detail.html( $(appstle_plan_wrap + ':nth(' + 0 + ') .appstleSellingPlanDescription').html() );
        plan_1.prop('checked', true);
      } else if ( freq == 2 ){
        active_plan.val(plan_2.val());
        fbs_plan_txt.html( $(appstle_plan_wrap + ':nth(' + 1 + ') .sellingplan').html() );
        fbs_plan_detail.html( $(appstle_plan_wrap + ':nth(' + 1 + ') .appstleSellingPlanDescription').html() );
        plan_2.prop('checked', true);
      } else if ( freq == 3 ){
        active_plan.val(plan_3.val());
        fbs_plan_txt.html( $(appstle_plan_wrap + ':nth(' + 2 + ') .sellingplan').html()) ;
        fbs_plan_detail.html( $(appstle_plan_wrap + ':nth(' + 2 + ') .appstleSellingPlanDescription').html() );
        plan_3.prop('checked', true);
      } else if ( freq == 4 ){
        active_plan.val(plan_4.val());
        fbs_plan_txt.html( $(appstle_plan_wrap + ':nth(' + 3 + ') .sellingplan').html() );
        fbs_plan_detail.html( $(appstle_plan_wrap + ':nth(' + 3 + ') .appstleSellingPlanDescription').html() );
        plan_4.prop('checked', true);
      } 
    });
  }  
  //setup_frequency_buttons();
})